import { Link } from "react-router-dom";

import Text from "../../styleguide/Text";
import { isDevelop } from "../../helpers/apiHelper";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

function NavbarLogo({
  withEnvIndicator,
  style,
}: {
  withEnvIndicator?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div className="ml-2.5 flex h-full items-center" style={style}>
      <Link
        className="h-full rounded-control text-inherit no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-action"
        to="/"
        aria-label="Pagina principală">
        <img
          height={50}
          width={50}
          src={toAbsoluteUrl("/logo.svg")}
          alt="Ahead Translog"
        />
      </Link>
      {withEnvIndicator && isDevelop && (
        <Text variant="h1" className="ml-3 hidden lg:block">
          Develop
        </Text>
      )}
    </div>
  );
}

export default NavbarLogo;
